import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Get auth token
const getAuthToken = () => {
  return localStorage.getItem('admin_token');
};

// Get auth headers
const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Product API
export const productAPI = {
  // Get all products with filters
  getAll: async (params = {}) => {
    const response = await axios.get(`${API}/products`, { params });
    return response.data;
  },

  // Get single product
  getById: async (id) => {
    const response = await axios.get(`${API}/products/${id}`);
    return response.data;
  },

  // Create product
  create: async (productData) => {
    const response = await axios.post(`${API}/products`, productData, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // Update product
  update: async (id, productData) => {
    const response = await axios.put(`${API}/products/${id}`, productData, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // Delete product
  delete: async (id) => {
    const response = await axios.delete(`${API}/products/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // Bulk delete
  bulkDelete: async (productIds) => {
    const response = await axios.post(`${API}/products/bulk-delete`, {
      product_ids: productIds
    }, {
      headers: getAuthHeaders()
    });
    return response.data;
  }
};

// Category API
export const categoryAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/categories`);
    return response.data;
  }
};

// Upload API
export const uploadAPI = {
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await axios.post(`${API}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...getAuthHeaders()
      }
    });
    return response.data;
  }
};
